<template xmlns="http://www.w3.org/1999/html">
  <div class="shengsheng-page">
    <!-- 顶部整宽的酒图片 -->
    <img
      class="jiu-img"
      src="/static/images/shengsheng/jiu.png"
      alt="酒背景"
    >
    
    <!-- 结果页面内容 -->
    <div class="result-content">
      <div class="code-line">
        <span class="code-text">编码：</span>
        <span class="code-number">{{ formattedAntiCode }}</span>
      </div>
      <div class="message-line">{{ queryResult }}</div>
      
      <!-- join.png图片 - 只有当replyCode为300101或300102时才显示 -->
      <img
        v-if="showJoinButton"
        class="join-img"
        src="/static/images/shengsheng/join.png"
        alt="加入"
        @click="goToJoin"
      >
    </div>
  </div>
</template>

<style scoped>
.shengsheng-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  /* 用 bg.png 做全屏背景 */
  background: url("/static/images/shengsheng/bg.png") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.jiu-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: block;
}

.result-content {
  position: relative;
  z-index: 10;
  padding: 49vh 20px 20px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.code-line {
  margin-bottom: 20px;
  font-size: 16px;
  display: flex;
  align-items: baseline;
}

.code-text {
  font-weight: normal;
}

.code-number {
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 1em;
  line-height: 0.5;
  transform: scaleY(2);
  transform-origin: bottom center;
}

.message-line {
  font-size: 14px;
  max-width: 80%;
}

.join-img {
  margin-top: 5vh;
  max-width: 60vw;
  max-height: 30vh;
  filter: drop-shadow(0 8px 6px rgba(0, 0, 0, 0.3));
}
</style>

<script>
import { queryAnti, getWechatAuth } from '../../api/api'

export default {
  data() {
    return {
      eno: '138666725759', // 企业号
      antiCode: '', // 防伪码
      formattedAntiCode: '', // 格式化后的防伪码（每4位加空格）
      queryResult: '', // 查询结果
      showJoinButton: false, // 是否显示join按钮
      deptId: '' // 部门ID
    };
  },
  async mounted() {
    // 获取URL参数
    this.eno = this.$route.query.eno || this.eno;
    const code = this.$route.query.c || '';
    this.antiCode = code ? code.substring(0, 16) : '';
    
    // 格式化防伪码显示（每4位加空格）
    this.formattedAntiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    
    
    // 调用防伪查询接口
    if (this.antiCode && this.eno) {
      try {
        const res = await queryAnti(this.antiCode, this.eno);
        const data = res.data;
        
        if (data == null || data.code == "500") {
          alert("查询异常，请重新扫描防伪码进行查询");
          return;
        }
        
        // 处理查询结果
        const replyCode = data.data.replyCode;
        
        if (replyCode === "300101" || replyCode === "300102") {
          // 正品情况
          this.queryResult = data.data.replyData;
          this.showJoinButton = true; // 显示join按钮
          // 记录deptId
          this.deptId = data.data.deptId || '';
        } else if (replyCode === "300106") {
          // 防伪码不存在
          this.queryResult = "您查询的数码不存在！";
          this.showJoinButton = false; // 隐藏join按钮
        } else {
          // 其他情况
          this.queryResult = "查询结果异常，请联系客服";
          this.showJoinButton = false; // 隐藏join按钮
        }
      } catch (error) {
        console.error('防伪查询失败:', error);
        alert("查询失败，请稍后重试");
      }
    } else {
      alert("请使用正确入口进入进行查询");
    }
  },
  methods: {
    goToJoin() {
      // 每次点击都获取最新的微信授权
      const redirectUrl = window.location.origin + '/ssheng/join';
      const params = new URLSearchParams();
      params.append('eno', this.eno);
      params.append('c', this.antiCode);
      params.append('deptId', this.deptId);
      
      const fullRedirectUrl = redirectUrl + '?' + params.toString();
      
      getWechatAuth(encodeURIComponent(fullRedirectUrl), "wx099133a5b38815d5", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err => {
        alert("获取微信授权失败" + err);
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ShengSheng/Result.vue